const APP_VERSION = process.env.REACT_APP_VERSION;

export const APP_BRAND_TITLE = APP_VERSION ? `Проффитель ${APP_VERSION}` : "Проффитель";

/** Статические маршруты → заголовок вкладки. Пополняется по мере появления разделов. */
const ROUTE_TITLES = {
  "/": "Главная",
  "/spr/zal": "Кабинеты",
  "/spr/tov": "Товары, услуги",
  "/spr/kompl": "Комплекты",
  "/spr/sotr": "Сотрудники",
  "/spr/template-nazn": "Шаблоны назначений",
  "/spr/text": "Шаблоны",
  "/spr/holidays": "Праздники",
  "/spr/kassa": "Кассы",
  "/spr/servis": "Виды диагнозов и записей в дневник",
  "/hub/numbers": "Управление номерами",
  "/hub/dialogs": "Диалоги",
  "/hub/warehouse": "Склад",
  "/hub/nutrition": "Питание",
  "/hub/health": "Лечение",
  "/hub/service": "Сервис",
  "/hub/sprs": "Справочники",
  "/hub/help": "Помощь",
  "/spr/number": "Номера",
  "/spr/number-cat": "Категории номеров",
  "/spr/number-spr": "Дополнительные",
  "/number/price": "Прайс-листы",
  "/spr/pred": "Контрагенты",
  "/spr/status": "Статусы",
  "/spr/cards": "Карты",
  "/spr/card-vids": "Типы карт",
  "/doc/exp": "Путевки",
  "/doc/plat": "Платежи",
  "/warehouse/documents": "Накладные",
  "/warehouse/register": "Остатки",
  "/warehouse/movements": "Движения товаров",
  "/warehouse/product-card": "Карточка товара",
  "/bron": "Шахматка",
  "/nutrition/templates": "Шаблоны меню",
  "/nutrition/map": "Карта питания",
  "/nutrition/register": "Регистрация питания",
  "/nutrition/tables": "Залы и столы",
  "/nutrition/cost": "Стоимость питания",
  "/health/clients": "Клиенты",
  "/dialogs": "Диалоги",
  "/dialogs/channels": "Каналы",
  "/dialogs/agents": "Агенты",
  "/service/check-db": "Проверка базы",
  "/service/monitor": "Монитор",
  "/service/reports": "Отчёты",
  "/service/settings": "Настройки",
  "/help/about": "О программе"
};

/** Базовый URL вкладки для вложенных маршрутов (модалки и т.п.). */
export function getRouteTab(pathname) {
  const path = pathname === "" ? "/" : pathname;
  if (ROUTE_TITLES[path]) {
    return { title: ROUTE_TITLES[path], url: path };
  }
  if (path === "/numbers") {
    return { title: "Управление номерами", url: "/hub/numbers" };
  }
  if (pathname.startsWith("/health/clients/")) {
    return { title: "Клиенты", url: "/health/clients" };
  }
  if (pathname === "/spr/zal/new" || /^\/spr\/zal\/\d+$/.test(pathname)) {
    return { title: "Кабинеты", url: "/spr/zal" };
  }
  if (pathname === "/spr/tov/new" || /^\/spr\/tov\/\d+$/.test(pathname)) {
    return { title: "Товары, услуги", url: "/spr/tov" };
  }
  if (pathname === "/spr/sotr/new" || /^\/spr\/sotr\/\d+$/.test(pathname)) {
    return { title: "Сотрудники", url: "/spr/sotr" };
  }
  if (pathname === "/spr/number/new" || /^\/spr\/number\/\d+$/.test(pathname)) {
    return { title: "Номера", url: "/spr/number" };
  }
  if (pathname === "/spr/number-cat/new" || /^\/spr\/number-cat\/\d+$/.test(pathname)) {
    return { title: "Категории номеров", url: "/spr/number-cat" };
  }
  if (pathname === "/spr/number-spr/new" || /^\/spr\/number-spr\/\d+$/.test(pathname)) {
    return { title: "Дополнительные", url: "/spr/number-spr" };
  }
  if (pathname === "/number/price/new" || /^\/number\/price\/\d+$/.test(pathname)) {
    return { title: "Прайс-листы", url: "/number/price" };
  }
  if (pathname === "/spr/pred/new" || /^\/spr\/pred\/\d+$/.test(pathname)) {
    return { title: "Контрагенты", url: "/spr/pred" };
  }
  if (pathname === "/spr/status/new" || /^\/spr\/status\/\d+$/.test(pathname)) {
    return { title: "Статусы", url: "/spr/status" };
  }
  if (pathname === "/doc/exp/new" || /^\/doc\/exp\/\d+$/.test(pathname)) {
    return { title: "Путевки", url: "/doc/exp" };
  }
  if (pathname === "/warehouse/documents/new" || /^\/warehouse\/documents\/\d+$/.test(pathname)) {
    return { title: "Накладные", url: "/warehouse/documents" };
  }
  if (pathname === "/bron" || pathname.startsWith("/bron?")) {
    return { title: "Шахматка", url: "/bron" };
  }
  if (pathname.startsWith("/dialogs")) {
    if (pathname.startsWith("/dialogs/channels")) {
      return { title: "Каналы", url: "/dialogs/channels" };
    }
    if (pathname.startsWith("/dialogs/agents")) {
      return { title: "Агенты", url: "/dialogs/agents" };
    }
    return { title: "Диалоги", url: "/dialogs" };
  }
  return null;
}

/** Название вкладки браузера. */
export function formatWindowTitle(pathname) {
  if (pathname === "/" || pathname === "") return APP_BRAND_TITLE;
  if (pathname === "/health/clients/new") {
    return `Новый клиент — ${APP_BRAND_TITLE}`;
  }
  if (/^\/health\/clients\/\d+$/.test(pathname)) {
    return `Клиент — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/spr/zal/new") {
    return `Новый кабинет — ${APP_BRAND_TITLE}`;
  }
  if (/^\/spr\/zal\/\d+$/.test(pathname)) {
    return `Кабинет — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/spr/tov/new") {
    return `Новая услуга — ${APP_BRAND_TITLE}`;
  }
  if (/^\/spr\/tov\/\d+$/.test(pathname)) {
    return `Услуга — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/spr/sotr/new") {
    return `Новый сотрудник — ${APP_BRAND_TITLE}`;
  }
  if (/^\/spr\/sotr\/\d+$/.test(pathname)) {
    return `Сотрудник — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/spr/number/new") {
    return `Новый номер — ${APP_BRAND_TITLE}`;
  }
  if (/^\/spr\/number\/\d+$/.test(pathname)) {
    return `Номер — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/spr/number-cat/new") {
    return `Новая категория — ${APP_BRAND_TITLE}`;
  }
  if (/^\/spr\/number-cat\/\d+$/.test(pathname)) {
    return `Категория номера — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/spr/number-spr/new") {
    return `Новая запись справочника — ${APP_BRAND_TITLE}`;
  }
  if (/^\/spr\/number-spr\/\d+$/.test(pathname)) {
    return `Справочник — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/number/price/new") {
    return `Новый прайс-лист — ${APP_BRAND_TITLE}`;
  }
  if (/^\/number\/price\/\d+$/.test(pathname)) {
    return `Прайс-лист — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/spr/pred/new") {
    return `Новый контрагент — ${APP_BRAND_TITLE}`;
  }
  if (/^\/spr\/pred\/\d+$/.test(pathname)) {
    return `Контрагент — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/doc/exp/new") {
    return `Новая путевка — ${APP_BRAND_TITLE}`;
  }
  if (/^\/doc\/exp\/\d+$/.test(pathname)) {
    return `Путевка — ${APP_BRAND_TITLE}`;
  }
  if (pathname === "/warehouse/documents/new") {
    return `Новая накладная — ${APP_BRAND_TITLE}`;
  }
  if (/^\/warehouse\/documents\/\d+$/.test(pathname)) {
    return `Накладная — ${APP_BRAND_TITLE}`;
  }
  const tab = getRouteTab(pathname);
  if (tab) return `${tab.title} — ${APP_BRAND_TITLE}`;
  return APP_BRAND_TITLE;
}
